import React, { useState } from "react";
import { useEffect } from "react";
//import { Link } from "react-router-dom";
import axios from "axios";
import Url from "../global";
import "./globalList.scss";
import { useSelector } from "react-redux";
import moment from "moment";
import { exportTableToExcel } from "../utils/exportTableToExcel";
import * as FaIcons from "react-icons/fa";
import "./DataPersonListPegawai.scss"


const DataPersonListPegawai = () => {
  const [pegawais, setPegawais] = useState([]);
  const { pegawai } = useSelector((state) => state.auth);
  const [query, setQuery] = useState("");
  const [query2, setQuery2] = useState("all");
  const [queryStatus, setQueryStatus] = useState("all");
  const [order, setOrder] = useState("ASC");

  const unitOptions = Array.from(
    new Set(pegawais.map((pegawai) => pegawai.strUnit).filter(Boolean))
  ).sort((a, b) => a.localeCompare(b));

  const filterByStatus = (pegawai) => {
    if (queryStatus === "all") return true;
    return queryStatus === "active"
      ? Number(pegawai.deleted) !== 1
      : Number(pegawai.deleted) === 1;
  };

  const getNumericSortValue = (value) => {
    const digits = String(value ?? "").replace(/\D/g, "");
    const trimmed = digits.slice(5);
    const numeric = Number(trimmed || 0);
    return Number.isFinite(numeric) ? numeric : 0;
  };

  const sorting = (col) => {
    const sorted = [...pegawais].sort((a, b) => {
      if (col === "strNRY") {
        const aValue = String(a[col] ?? "").trim();
        const bValue = String(b[col] ?? "").trim();
        const aEmpty = aValue === "" || aValue === "0";
        const bEmpty = bValue === "" || bValue === "0";

        if (aEmpty && bEmpty) return 0;
        if (aEmpty) return 1;
        if (bEmpty) return -1;

        const left = getNumericSortValue(a[col]);
        const right = getNumericSortValue(b[col]);
        return order === "ASC" ? left - right : right - left;
      }

      if (typeof a[col] === "string" && typeof b[col] === "string") {
        return order === "ASC"
          ? a[col].localeCompare(b[col])
          : b[col].localeCompare(a[col]);
      } else {
        return order === "ASC" ? a[col] - b[col] : b[col] - a[col];
      }
    });

    setPegawais(sorted);
    setOrder(order === "ASC" ? "DSC" : "ASC");
  };

  useEffect(() => {
    getPegawais();
  }, []);

  const getPegawais = async () => {
    const response = await axios.get(`${Url}/pegawai`);
    const sortedData = [...response.data].sort((a, b) => {
      const aValue = String(a.strNRY ?? "").trim();
      const bValue = String(b.strNRY ?? "").trim();
      const aEmpty = aValue === "" || aValue === "0";
      const bEmpty = bValue === "" || bValue === "0";

      if (aEmpty && bEmpty) return 0;
      if (aEmpty) return 1;
      if (bEmpty) return -1;

      const digitsA = String(aValue).replace(/\D/g, "");
      const digitsB = String(bValue).replace(/\D/g, "");
      const left = Number(digitsA.slice(5) || 0);
      const right = Number(digitsB.slice(5) || 0);

      return left - right;
    });

    setPegawais(sortedData);
  };

  return (
    <div>
      <h1 className="title">Pegawai</h1>
      <h2 className="subtitle">List Of Pegawai</h2>
      <br />

      <button
        type="button"
        className="download-table-xls-button"
        onClick={() =>
          exportTableToExcel({
            tableId: "table-to-xls",
            filename: "Table Pegawai List",
          })
        }
      >
        Download as XLS
      </button>
      <br />
      <div className="filter-row">
        {pegawai &&
          (pegawai.strRole === "admin" ||
            pegawai.strRole === "kabid kepegawaian" ||
            pegawai.strRole === "kepsek" ||
            pegawai.strRole === "staff TU") && (
            <div className="filter-item">
              <label>Masukan Nama</label>
              <input
                className="search"
                placeholder="Cari Nama Individu"
                onChange={(e) => setQuery(e.target.value.toLowerCase())}
              />
            </div>
          )}

        {pegawai && (pegawai.strRole === "admin" || pegawai.strRole === "kabid kepegawaian") && (
          <div className="filter-item">
            <label>Filter Unit</label>
            <select
              className="search"
              value={query2}
              onChange={(e) => setQuery2(e.target.value)}
            >
              <option value="all">Semua Unit</option>
              {unitOptions.map((unit) => (
                <option key={unit} value={unit}>
                  {unit}
                </option>
              ))}
            </select>
          </div>
        )}

        {pegawai &&
          (pegawai.strRole === "admin" ||
            pegawai.strRole === "kabid kepegawaian" ||
            pegawai.strRole === "kepsek" ||
            pegawai.strRole === "staff TU") && (
            <div className="filter-item">
              <label>Filter Status</label>
              <select
                className="search"
                value={queryStatus}
                onChange={(e) => setQueryStatus(e.target.value)}
              >
                <option value="all">Semua Status</option>
                <option value="active">Aktif</option>
                <option value="inactive">Tidak Aktif</option>
              </select>
            </div>
          )}
      </div>

      <div className="table__wrapper_Scroll_Log">
        <table
          className="table is-bordered is-striped is-narrow is-hoverable is-fullwidth"
          id="table-to-xls"
        >
          <thead className="flat">
            <tr>
              <th className="has-text-centered">No</th>
              <th
                className="has-text-centered"
                onClick={() => sorting("strNama")}
              >
                {" "}
                Nama <FaIcons.FaSort />
              </th>
              <th className="has-text-centered">NIK</th>
              <th className="has-text-centered" onClick={() => sorting("strNRY")}>
                NRY <FaIcons.FaSort />
              </th>
              <th className="has-text-centered">Nomor Telpon</th>
              <th className="has-text-centered">Unit</th>
              <th className="has-text-centered">Gender</th>
              <th className="has-text-centered">Email</th>
              <th className="has-text-centered">Tanggal Lahir</th>
              <th className="has-text-centered">Tempat Lahir</th>
              <th className="has-text-centered">Alamat</th>
              <th className="has-text-centered">Nama Ayah</th>
              <th className="has-text-centered">Nama Ibu</th>
              <th className="has-text-centered">Tanggal Masuk Al Hasanah</th>
              <th className="has-text-centered">Tanggal Habis Kontrak</th>
              <th className="has-text-centered">Jabatan</th>
              <th className="has-text-centered">NPWP</th>
              <th className="has-text-centered">BPJSKES</th>
              <th className="has-text-centered">BPJSTK</th>
              <th className="has-text-centered">Pendidikan Terakhir</th>
              {/* <th className="has-text-centered">Jumlah Jam Kerja</th> */}
              <th className="has-text-centered">Jenis Pegawai</th>
              <th className="has-text-centered" onClick={() => sorting("deleted")}>
                Aktif <FaIcons.FaSort />
              </th>

            </tr>
          </thead>

          {pegawai && (pegawai.strRole === "admin" || pegawai.strRole === "kabid kepegawaian") && (
            <tbody>
              {pegawais
                .filter(
                  (pegawai) =>
                    filterByStatus(pegawai) &&
                    pegawai.strNama.toLowerCase().includes(query) &&
                    (query2 === "all" || pegawai.strUnit === query2)
                )
                .map((pegawai, index) => (
                  <tr key={pegawai.uuid}>
                    <td className="has-text-centered">{index + 1}</td>
                    <td width="15px">{pegawai.strNama}</td>
                    <td>'{pegawai.strNIK}</td>
                    <td>'{pegawai.strNRY}</td>
                    <td>'{pegawai.strTelpon}</td>
                    <td>{pegawai.strUnit}</td>
                    <td>{pegawai.strGender}</td>
                    <td>{pegawai.strEmail}</td>
                    <td>
                      {pegawai.dateTanggalLahir ? moment(pegawai.dateTanggalLahir).format("DD/MM/YYYY") : " "}
                    </td>


                    <td>{pegawai.strTempatLahir}</td>
                    <td>{pegawai.strAlamat}</td>
                    <td>{pegawai.strNamaAyah}</td>
                    <td>{pegawai.strNamaIbu}</td>
                    <td>
                      {pegawai.dateTanggalMasuk ? moment(pegawai.dateTanggalMasuk).format("DD/MM/YYYY") : " "}
                    </td>
                    <td>
                      {pegawai.dateMasaKontrak ? moment(pegawai.dateMasaKontrak).format("DD/MM/YYYY") : " "}
                    </td>

                    <td>{pegawai.strJabatan}</td>
                    <td>
                      {pegawai.strNPWP
                        ? pegawai.strNPWP.substring(0, 2) +
                        "." +
                        pegawai.strNPWP.substring(2, 5) +
                        "." +
                        pegawai.strNPWP.substring(5, 8) +
                        "-" +
                        pegawai.strNPWP.substring(8, 9) +
                        "." +
                        (pegawai.strNPWP.substring(9, 12) +
                          "." +
                          pegawai.strNPWP.substring(12, 15))
                        : ""}
                    </td>
                    <td>{pegawai.strBPJS}</td>
                    <td>{pegawai.strBPJSTK}</td>
                    <td>{pegawai.strPendidikanTerakhir}</td>
                    {/* <td>{pegawai.strJumlahJamKerja}</td> */}
                    <td>{pegawai.strJenisKaryawan}</td>
                    <td>{Number(pegawai.deleted) === 1 ? "Tidak Aktif" : "Aktif"}</td>
                  </tr>
                ))}
            </tbody>
          )}

          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "PAUD IT Al Hasanah 1" && (
              <tbody>
                {pegawais
                  .filter(
                    (pegawai) =>
                      filterByStatus(pegawai) &&
                      pegawai.strNama.toLowerCase().includes(query)
                  )
                  .map((pegawai, index) =>
                    pegawai.strUnit === "PAUD IT Al Hasanah 1" ? (
                      <tr key={pegawai.uuid}>
                        <td className="has-text-centered">{index + 1}</td>
                        <td width="15px">{pegawai.strNama}</td>
                        <td>'{pegawai.strNIK}</td>
                        <td>'{pegawai.strNRY}</td>
                        <td>{pegawai.strTelpon}</td>
                        <td>{pegawai.strUnit}</td>
                        <td>{pegawai.strGender}</td>
                        <td>{pegawai.strEmail}</td>
                        <td>
                          {pegawai.dateTanggalLahir ? moment(pegawai.dateTanggalLahir).format("DD/MM/YYYY") : " "}
                        </td>

                        <td>{pegawai.strTempatLahir}</td>
                        <td>{pegawai.strAlamat}</td>
                        <td>{pegawai.strNamaAyah}</td>
                        <td>{pegawai.strNamaIbu}</td>
                        <td>
                          {pegawai.dateTanggalMasuk ? moment(pegawai.dateTanggalMasuk).format("DD/MM/YYYY") : " "}
                        </td>
                        <td>
                          {pegawai.dateMasaKontrak ? moment(pegawai.dateMasaKontrak).format("DD/MM/YYYY") : " "}
                        </td>


                        <td>{pegawai.strJabatan}</td>
                        <td>
                          {pegawai.strNPWP
                            ? pegawai.strNPWP.substring(0, 2) +
                            "." +
                            pegawai.strNPWP.substring(2, 5) +
                            "." +
                            pegawai.strNPWP.substring(5, 8) +
                            "-" +
                            pegawai.strNPWP.substring(8, 9) +
                            "." +
                            (pegawai.strNPWP.substring(9, 12) +
                              "." +
                              pegawai.strNPWP.substring(12, 15))
                            : ""}
                        </td>
                        <td>{pegawai.strBPJS}</td>
                        <td>{pegawai.strBPJSTK}</td>
                        <td>{pegawai.strPendidikanTerakhir}</td>
                        <td>{pegawai.strJenisKaryawan}</td>
                        <td>{Number(pegawai.deleted) === 1 ? "Tidak Aktif" : "Aktif"}</td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}

          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "PAUD IT Al Hasanah 2" && (
              <tbody>
                {pegawais
                  .filter(
                    (pegawai) =>
                      filterByStatus(pegawai) &&
                      pegawai.strNama.toLowerCase().includes(query)
                  )
                  .map((pegawai, index) =>
                    pegawai.strUnit === "PAUD IT Al Hasanah 2" ? (
                      <tr key={pegawai.uuid}>
                        <td className="has-text-centered">{index + 1}</td>
                        <td width="15px">{pegawai.strNama}</td>
                        <td>'{pegawai.strNIK}</td>
                        <td>'{pegawai.strNRY}</td>
                        <td>{pegawai.strTelpon}</td>
                        <td>{pegawai.strUnit}</td>
                        <td>{pegawai.strGender}</td>
                        <td>{pegawai.strEmail}</td>
                        <td>
                          {pegawai.dateTanggalLahir ? moment(pegawai.dateTanggalLahir).format("DD/MM/YYYY") : " "}
                        </td>

                        <td>{pegawai.strTempatLahir}</td>
                        <td>{pegawai.strAlamat}</td>
                        <td>{pegawai.strNamaAyah}</td>
                        <td>{pegawai.strNamaIbu}</td>
                        <td>
                          {pegawai.dateTanggalMasuk ? moment(pegawai.dateTanggalMasuk).format("DD/MM/YYYY") : " "}
                        </td>
                        <td>
                          {pegawai.dateMasaKontrak ? moment(pegawai.dateMasaKontrak).format("DD/MM/YYYY") : " "}
                        </td>

                        <td>{pegawai.strJabatan}</td>
                        <td>
                          {pegawai.strNPWP
                            ? pegawai.strNPWP.substring(0, 2) +
                            "." +
                            pegawai.strNPWP.substring(2, 5) +
                            "." +
                            pegawai.strNPWP.substring(5, 8) +
                            "-" +
                            pegawai.strNPWP.substring(8, 9) +
                            "." +
                            (pegawai.strNPWP.substring(9, 12) +
                              "." +
                              pegawai.strNPWP.substring(12, 15))
                            : ""}
                        </td>
                        <td>{pegawai.strBPJS}</td>
                        <td>{pegawai.strBPJSTK}</td>
                        <td>{pegawai.strPendidikanTerakhir}</td>
                        <td>{pegawai.strJenisKaryawan}</td>
                        <td>{Number(pegawai.deleted) === 1 ? "Tidak Aktif" : "Aktif"}</td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}

          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "SDIT Al Hasanah 1" && (
              <tbody>
                {pegawais
                  .filter(
                    (pegawai) =>
                      filterByStatus(pegawai) &&
                      pegawai.strNama.toLowerCase().includes(query)
                  )
                  .map((pegawai, no) =>
                    pegawai.strUnit === "SDIT Al Hasanah 1" ? (
                      <tr key={pegawai.uuid}>
                        <td className="has-text-centered">{no + 1}</td>
                        <td width="15px">{pegawai.strNama}</td>
                        <td>'{pegawai.strNIK}</td>
                        <td>'{pegawai.strNRY}</td>
                        <td>{pegawai.strTelpon}</td>
                        <td>{pegawai.strUnit}</td>
                        <td>{pegawai.strGender}</td>
                        <td>{pegawai.strEmail}</td>
                        <td>
                          {pegawai.dateTanggalLahir ? moment(pegawai.dateTanggalLahir).format("DD/MM/YYYY") : " "}
                        </td>

                        <td>{pegawai.strTempatLahir}</td>
                        <td>{pegawai.strAlamat}</td>
                        <td>{pegawai.strNamaAyah}</td>
                        <td>{pegawai.strNamaIbu}</td>
                        <td>
                          {pegawai.dateTanggalMasuk ? moment(pegawai.dateTanggalMasuk).format("DD/MM/YYYY") : " "}
                        </td>
                        <td>
                          {pegawai.dateMasaKontrak ? moment(pegawai.dateMasaKontrak).format("DD/MM/YYYY") : " "}
                        </td>

                        <td>{pegawai.strJabatan}</td>
                        <td>
                          {pegawai.strNPWP
                            ? pegawai.strNPWP.substring(0, 2) +
                            "." +
                            pegawai.strNPWP.substring(2, 5) +
                            "." +
                            pegawai.strNPWP.substring(5, 8) +
                            "-" +
                            pegawai.strNPWP.substring(8, 9) +
                            "." +
                            (pegawai.strNPWP.substring(9, 12) +
                              "." +
                              pegawai.strNPWP.substring(12, 15))
                            : ""}
                        </td>
                        <td>{pegawai.strBPJS}</td>
                        <td>{pegawai.strBPJSTK}</td>
                        <td>{pegawai.strPendidikanTerakhir}</td>
                        <td>{pegawai.strJenisKaryawan}</td>
                        <td>{Number(pegawai.deleted) === 1 ? "Tidak Aktif" : "Aktif"}</td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}

          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "SDIT Al Hasanah 2" && (
              <tbody>
                {pegawais
                  .filter(
                    (pegawai) =>
                      filterByStatus(pegawai) &&
                      pegawai.strNama.toLowerCase().includes(query)
                  )
                  .map((pegawai, index) =>
                    pegawai.strUnit === "SDIT Al Hasanah 2" ? (
                      <tr key={pegawai.uuid}>
                        <td className="has-text-centered">{index + 1}</td>
                        <td width="15px">{pegawai.strNama}</td>
                        <td>'{pegawai.strNIK}</td>
                        <td>'{pegawai.strNRY}</td>
                        <td>{pegawai.strTelpon}</td>
                        <td>{pegawai.strUnit}</td>
                        <td>{pegawai.strGender}</td>
                        <td>{pegawai.strEmail}</td>
                        <td>
                          {pegawai.dateTanggalLahir ? moment(pegawai.dateTanggalLahir).format("DD/MM/YYYY") : " "}
                        </td>

                        <td>{pegawai.strTempatLahir}</td>
                        <td>{pegawai.strAlamat}</td>
                        <td>{pegawai.strNamaAyah}</td>
                        <td>{pegawai.strNamaIbu}</td>
                        <td>
                          {pegawai.dateTanggalMasuk ? moment(pegawai.dateTanggalMasuk).format("DD/MM/YYYY") : " "}
                        </td>
                        <td>
                          {pegawai.dateMasaKontrak ? moment(pegawai.dateMasaKontrak).format("DD/MM/YYYY") : " "}
                        </td>

                        <td>{pegawai.strJabatan}</td>
                        <td>
                          {pegawai.strNPWP
                            ? pegawai.strNPWP.substring(0, 2) +
                            "." +
                            pegawai.strNPWP.substring(2, 5) +
                            "." +
                            pegawai.strNPWP.substring(5, 8) +
                            "-" +
                            pegawai.strNPWP.substring(8, 9) +
                            "." +
                            (pegawai.strNPWP.substring(9, 12) +
                              "." +
                              pegawai.strNPWP.substring(12, 15))
                            : ""}
                        </td>
                        <td>{pegawai.strBPJS}</td>
                        <td>{pegawai.strBPJSTK}</td>
                        <td>{pegawai.strPendidikanTerakhir}</td>
                        <td>{pegawai.strJenisKaryawan}</td>
                        <td>{Number(pegawai.deleted) === 1 ? "Tidak Aktif" : "Aktif"}</td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}

          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "SMPI Al Hasanah" && (
              <tbody>
                {pegawais
                  .filter(
                    (pegawai) =>
                      filterByStatus(pegawai) &&
                      pegawai.strNama.toLowerCase().includes(query)
                  )
                  .map((pegawai, index) =>
                    pegawai.strUnit === "SMPI Al Hasanah" ? (
                      <tr key={pegawai.uuid}>
                        <td className="has-text-centered">{index + 1}</td>
                        <td width="15px">{pegawai.strNama}</td>
                        <td>'{pegawai.strNIK}</td>
                        <td>'{pegawai.strNRY}</td>
                        <td>{pegawai.strTelpon}</td>
                        <td>{pegawai.strUnit}</td>
                        <td>{pegawai.strGender}</td>
                        <td>{pegawai.strEmail}</td>
                        <td>
                          {pegawai.dateTanggalLahir ? moment(pegawai.dateTanggalLahir).format("DD/MM/YYYY") : " "}
                        </td>

                        <td>{pegawai.strTempatLahir}</td>
                        <td>{pegawai.strAlamat}</td>
                        <td>{pegawai.strNamaAyah}</td>
                        <td>{pegawai.strNamaIbu}</td>
                        <td>
                          {pegawai.dateTanggalMasuk ? moment(pegawai.dateTanggalMasuk).format("DD/MM/YYYY") : " "}
                        </td>
                        <td>
                          {pegawai.dateMasaKontrak ? moment(pegawai.dateMasaKontrak).format("DD/MM/YYYY") : " "}
                        </td>

                        <td>{pegawai.strJabatan}</td>
                        <td>
                          {pegawai.strNPWP
                            ? pegawai.strNPWP.substring(0, 2) +
                            "." +
                            pegawai.strNPWP.substring(2, 5) +
                            "." +
                            pegawai.strNPWP.substring(5, 8) +
                            "-" +
                            pegawai.strNPWP.substring(8, 9) +
                            "." +
                            (pegawai.strNPWP.substring(9, 12) +
                              "." +
                              pegawai.strNPWP.substring(12, 15))
                            : ""}
                        </td>
                        <td>{pegawai.strBPJS}</td>
                        <td>{pegawai.strBPJSTK}</td>
                        <td>{pegawai.strPendidikanTerakhir}</td>
                        <td>{pegawai.strJenisKaryawan}</td>
                        <td>{Number(pegawai.deleted) === 1 ? "Tidak Aktif" : "Aktif"}</td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}

          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "SMAIT Al Hasanah" && (
              <tbody>
                {pegawais
                  .filter(
                    (pegawai) =>
                      filterByStatus(pegawai) &&
                      pegawai.strNama.toLowerCase().includes(query)
                  )
                  .map((pegawai, index) => (
                    <tr key={pegawai.uuid}>
                      <td className="has-text-centered">{index + 1}</td>
                      <td width="15px">{pegawai.strNama}</td>
                      <td>'{pegawai.strNIK}</td>
                      <td>'{pegawai.strNRY}</td>
                      <td>{pegawai.strTelpon}</td>
                      <td>{pegawai.strUnit}</td>
                      <td>{pegawai.strGender}</td>
                      <td>{pegawai.strEmail}</td>
                      <td>
                        {pegawai.dateTanggalLahir ? moment(pegawai.dateTanggalLahir).format("DD/MM/YYYY") : " "}
                      </td>

                      <td>{pegawai.strTempatLahir}</td>
                      <td>{pegawai.strAlamat}</td>
                      <td>{pegawai.strNamaAyah}</td>
                      <td>{pegawai.strNamaIbu}</td>
                      <td>
                        {pegawai.dateTanggalMasuk ? moment(pegawai.dateTanggalMasuk).format("DD/MM/YYYY") : " "}
                      </td>
                      <td>
                        {pegawai.dateMasaKontrak ? moment(pegawai.dateMasaKontrak).format("DD/MM/YYYY") : " "}
                      </td>

                      <td>{pegawai.strJabatan}</td>
                      <td>
                        {pegawai.strNPWP
                          ? pegawai.strNPWP.substring(0, 2) +
                          "." +
                          pegawai.strNPWP.substring(2, 5) +
                          "." +
                          pegawai.strNPWP.substring(5, 8) +
                          "-" +
                          pegawai.strNPWP.substring(8, 9) +
                          "." +
                          (pegawai.strNPWP.substring(9, 12) +
                            "." +
                            pegawai.strNPWP.substring(12, 15))
                          : ""}
                      </td>
                      <td>{pegawai.strBPJS}</td>
                      <td>{pegawai.strBPJSTK}</td>
                      <td>{pegawai.strPendidikanTerakhir}</td>
                      <td>{pegawai.strJenisKaryawan}</td>
                      <td>{Number(pegawai.deleted) === 1 ? "Tidak Aktif" : "Aktif"}</td>
                    </tr>
                  ))}
              </tbody>
            )}

          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "Pondok Pesantren" && (
              <tbody>
                {pegawais
                  .filter(
                    (pegawai) =>
                      filterByStatus(pegawai) &&
                      pegawai.strNama.toLowerCase().includes(query)
                  )
                  .map((pegawai, index) =>
                    pegawai.strUnit === "Pondok Pesantren" ? (
                      <tr key={pegawai.uuid}>
                        <td className="has-text-centered">{index + 1}</td>
                        <td width="15px">{pegawai.strNama}</td>
                        <td>'{pegawai.strNIK}</td>
                        <td>'{pegawai.strNRY}</td>
                        <td>{pegawai.strTelpon}</td>
                        <td>{pegawai.strUnit}</td>
                        <td>{pegawai.strGender}</td>
                        <td>{pegawai.strEmail}</td>
                        <td>
                          {pegawai.dateTanggalLahir ? moment(pegawai.dateTanggalLahir).format("DD/MM/YYYY") : " "}
                        </td>

                        <td>{pegawai.strTempatLahir}</td>
                        <td>{pegawai.strAlamat}</td>
                        <td>{pegawai.strNamaAyah}</td>
                        <td>{pegawai.strNamaIbu}</td>
                        <td>
                          {pegawai.dateTanggalMasuk ? moment(pegawai.dateTanggalMasuk).format("DD/MM/YYYY") : " "}
                        </td>
                        <td>
                          {pegawai.dateMasaKontrak ? moment(pegawai.dateMasaKontrak).format("DD/MM/YYYY") : " "}
                        </td>

                        <td>{pegawai.strJabatan}</td>
                        <td>
                          {pegawai.strNPWP
                            ? pegawai.strNPWP.substring(0, 2) +
                            "." +
                            pegawai.strNPWP.substring(2, 5) +
                            "." +
                            pegawai.strNPWP.substring(5, 8) +
                            "-" +
                            pegawai.strNPWP.substring(8, 9) +
                            "." +
                            (pegawai.strNPWP.substring(9, 12) +
                              "." +
                              pegawai.strNPWP.substring(12, 15))
                            : ""}
                        </td>
                        <td>{pegawai.strBPJS}</td>
                        <td>{pegawai.strBPJSTK}</td>
                        <td>{pegawai.strPendidikanTerakhir}</td>
                        <td>{pegawai.strJenisKaryawan}</td>
                        <td>{Number(pegawai.deleted) === 1 ? "Tidak Aktif" : "Aktif"}</td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}


        </table>
      </div>
    </div>
  );
};

export default DataPersonListPegawai;
